export const Color = {
    DeleteRed: 'var(--base-color-delete-red',
    Red: 'var(--base-color-red)',
    LightGrey: 'var(--base-color-light-gray)',
    DarkGrey: 'var(--base-color-dark-gray)',
    Grey: 'var(--base-color-gray)',
    Teal: 'var(--base-color-teal)',
    Green: 'var(--base-color-green)',
    DarkGreen: 'var(--base-color-dark-green)',
    DarkBlue: 'var(--base-color-dark-blue)',
    White: 'White',
    Black: 'Black'
}